module.exports = __webpack_public_path__ + "img/one_1.a7f7aa97.png";